import { useSelector } from 'react-redux';

import WorkspaceMeetingModeHelper from 'Shared/model_helpers/WorkspaceMeetingMode.helper';
import * as UsersSelectors from 'Shared/selectors/Users.selectors';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

export const useCurrentlyTypingParticipants = meetingModeSession => {
  const now = Math.floor(Date.now() / 1000);
  const { id: currentUserId } = useCurrentUser();
  const typingParticipants = WorkspaceMeetingModeHelper.getTypingParticipants(meetingModeSession).toJS();
  const participantIds = Object.keys(typingParticipants).filter(
    // Find the user ID that isn't current user, and has been logged as typing in the last 5 seconds
    i => parseInt(i, 10) !== currentUserId && now - (typingParticipants[i] || 0) < 5
  );

  const users = useSelector(state =>
    UsersSelectors.getUsersByUserIds(state, { userIds: participantIds.map(id => parseInt(id, 10)) })
  );

  return users;
};
